export const environment = {
  production: true,
  apiUrl: 'https://development.survey.renovars.fullstackagency.it/api',
  tokenLength: 6,
  showWelcomePage: false,
};
